import { Vehicle } from "../types/Vehicle";
import actros from "../assets/images/actros.jpeg"

export const fleetData : Vehicle[] = [
    {
        name:"Mercedes-Benz Actros 2548",
        image:actros
    },
]